import {z} from "../../../../../lib";
import {
    OperacionLCLSCuentaFields,
    OperacionLCLSCuentaLimiteFields,
    OperacionLCLSFields,
    OperacionLCLSLimiteAprobadoFields, OperacionLCLSLimitesAprobadosPaisFields,
    OperacionLCLSLimitesAprobadosUnidadNegocioFields,
    OperacionLCLSRelacionFields,
    OperacionLCLSSectorComercialFields,
    OperacionLCLSUnidadNegocioFields
} from "./fields";
import {schemaEntityWithId, schemaEntityWithIdAndDescription} from "../../../../../types";
import { schemaStringObligatorio } from "src/pages/sistema/types/types";

export const schemaOperacionLCLSCuentaInsert = z.object({
    [OperacionLCLSCuentaFields.NroCuenta]: schemaStringObligatorio,
    [OperacionLCLSCuentaFields.RazonSocial]: schemaStringObligatorio,
    [OperacionLCLSCuentaFields.Moneda]: z.string(),
    [OperacionLCLSCuentaFields.CodClienteTipo]: z.number().nullable(),
    [OperacionLCLSCuentaFields.CodClienteSubTipo]: z.number().nullable(),
    [OperacionLCLSCuentaFields.LimiteConcertacion]: z.preprocess(
        (val) => (val === '' ? null : val),
        z.coerce.number({
            required_error: 'El límite es requerido.',
            invalid_type_error: 'El límite debe ser un número.'
        })
    ),
    [OperacionLCLSCuentaFields.LimiteLiquidacionDVP]: z.preprocess(
        (val) => (val === '' ? null : val),
        z.coerce.number({
            required_error: 'El límite es requerido.',
            invalid_type_error: 'El límite debe ser un número.'
        })
    ),
    [OperacionLCLSCuentaFields.LimiteLiquidacionFOP]: z.preprocess(
        (val) => (val === '' ? null : val),
        z.coerce.number({
            required_error: 'El límite es requerido.',
            invalid_type_error: 'El límite debe ser un número.'
        })
    ),
});
export type OperacionLCLSCuentaInsert = z.infer<typeof schemaOperacionLCLSCuentaInsert>;

export const schemaOperacionLCLSInsert = z.object({
    [OperacionLCLSFields.CodPais]: z.number(),
    [OperacionLCLSFields.CodUnidadNegocio]: z.number(),
    [OperacionLCLSFields.CodSectorComercial]: z.number(),
    [OperacionLCLSFields.FechaSolicitud]: z.date(),
    [OperacionLCLSFields.FechaVencimiento]: z.date(),
    [OperacionLCLSFields.Observaciones]: z.string().nullable().optional(),

    [OperacionLCLSFields.Cuentas]: z.array(schemaOperacionLCLSCuentaInsert),
});
export type OperacionLCLSInsert = z.infer<typeof schemaOperacionLCLSInsert>;

export const schemaOperacionLCLSCuentaLimiteUpdate = z.object({
    [OperacionLCLSCuentaLimiteFields.LimiteConcertacion]: z.preprocess(
        (val) => (val === '' ? null : val),
        z.coerce.number({
            required_error: 'El límite es requerido.',
            invalid_type_error: 'El límite debe ser un número.'
        })
    ),
    [OperacionLCLSCuentaLimiteFields.LimiteLiquidacionDVP]: z.preprocess(
        (val) => (val === '' ? null : val),
        z.coerce.number({
            required_error: 'El límite es requerido.',
            invalid_type_error: 'El límite debe ser un número.'
        })
    ),
    [OperacionLCLSCuentaLimiteFields.LimiteLiquidacionFOP]: z.preprocess(
        (val) => (val === '' ? null : val),
        z.coerce.number({
            required_error: 'El límite es requerido.',
            invalid_type_error: 'El límite debe ser un número.'
        })
    )
});
export type OperacionLCLSCuentaLimiteUpdate = z.infer<typeof schemaOperacionLCLSCuentaLimiteUpdate>;

export const schemaOperacionLCLSLimiteTipo = z
    .object({

        [OperacionLCLSFields.Monto]: z.number(),
    })
    .merge(schemaEntityWithIdAndDescription)
export type OperacionLCLSLimiteTipo = z.infer<typeof schemaOperacionLCLSLimiteTipo>

export const schemaOperacionLCLSUnidadNegocio = z
    .object({

        [OperacionLCLSUnidadNegocioFields.CodUnidadNegocio]: z.number(),
    })
    .merge(schemaEntityWithIdAndDescription)
export type OperacionLCSLSUnidadNegocio = z.infer<typeof schemaOperacionLCLSUnidadNegocio>

export const schemaOperacionLCLSSectorComercial = z
    .object({

        [OperacionLCLSSectorComercialFields.CodSectorComercial]: z.number(),
    })
    .merge(schemaEntityWithIdAndDescription)
export type OperacionLCSLSSectorComercial = z.infer<typeof schemaOperacionLCLSSectorComercial>

export const schemaOperacionLCLSCuentaLimiteVista = z.object({
    [OperacionLCLSCuentaLimiteFields.CodGrupo]: z.number(),
    [OperacionLCLSCuentaLimiteFields.DescGrupo]: z.string(),
    [OperacionLCLSCuentaLimiteFields.LimiteConcertacion]: z.number(),
    [OperacionLCLSCuentaLimiteFields.LimiteLiquidacionDVP]: z.number(),
    [OperacionLCLSCuentaLimiteFields.LimiteLiquidacionFOP]: z.number(),
    [OperacionLCLSCuentaLimiteFields.PermiteModificar]: z.boolean(),
    [OperacionLCLSCuentaLimiteFields.FechaAccion]: z.coerce.date().nullable(),
}).merge(schemaEntityWithId);
export type OperacionLCLSCuentaLimiteVista = z.infer<typeof schemaOperacionLCLSCuentaLimiteVista>;

export const schemaOperacionLCLSCuentaVista = z.object({
    [OperacionLCLSCuentaFields.NroCuenta]: z.string(),
    [OperacionLCLSCuentaFields.RazonSocial]: z.string(),
    [OperacionLCLSCuentaFields.Moneda]: z.string(),
    [OperacionLCLSCuentaFields.DescClienteTipo]: z.string().nullable(),
    [OperacionLCLSCuentaFields.DescClienteSubTipo]: z.string().nullable(),
    limites: z.array(schemaOperacionLCLSCuentaLimiteVista),
}).merge(schemaEntityWithId);
export type OperacionLCLSCuentaVista = z.infer<typeof schemaOperacionLCLSCuentaVista>;

export const schemaOperacionLCLSCuentaLimiteAprobado = z.object({
    [OperacionLCLSLimiteAprobadoFields.CodPais]: z.number(),
    [OperacionLCLSLimiteAprobadoFields.CodSistema]: z.number(),
    [OperacionLCLSLimiteAprobadoFields.CodUnidadNegocio]: z.number(),
    [OperacionLCLSLimiteAprobadoFields.NroCuenta]: z.string(),
    [OperacionLCLSLimiteAprobadoFields.RazonSocial]: z.string(),
    [OperacionLCLSLimiteAprobadoFields.Moneda]: z.string(),
    [OperacionLCLSLimiteAprobadoFields.LimiteConcertacion]: z.number(),
    [OperacionLCLSLimiteAprobadoFields.LimiteDVP]: z.number(),
    [OperacionLCLSLimiteAprobadoFields.LimiteFOP]: z.number(),
    [OperacionLCLSLimiteAprobadoFields.FechaAlta]: z.coerce.date(),
    [OperacionLCLSLimiteAprobadoFields.UsuarioUltMod]: z.string(),
    [OperacionLCLSLimiteAprobadoFields.IdMensaje]: z.number(),
    [OperacionLCLSLimiteAprobadoFields.FechaAprobacion]: z.coerce.date().nullable(),
    [OperacionLCLSLimiteAprobadoFields.NombrePais]: z.string(),
    [OperacionLCLSLimiteAprobadoFields.CodSistemaPrincipal]: z.number(),
}).merge(schemaEntityWithId);

export type OperacionLCLSCuentaLimiteAprobado = z.infer<typeof schemaOperacionLCLSCuentaLimiteAprobado>;


export const schemaOperacionLCLSCuentaLimitesAprobadosUnidadNegocio = z.object({
    [OperacionLCLSLimitesAprobadosUnidadNegocioFields.CodUnidadNegocio]: z.number(),
    [OperacionLCLSLimitesAprobadosUnidadNegocioFields.DescUnidadNegocio]: z.string().optional(),
    [OperacionLCLSLimitesAprobadosUnidadNegocioFields.ListaLimites]: z.array(schemaOperacionLCLSCuentaLimiteAprobado)
});

export type OperacionLCLSCuentaLimitesAprobadosUnidadNegocio = z.infer<typeof schemaOperacionLCLSCuentaLimitesAprobadosUnidadNegocio>;


export const schemaOperacionLCLSCuentaLimitesAprobadosPais = z.object({
    [OperacionLCLSLimitesAprobadosPaisFields.CodPais]: z.number(),
    [OperacionLCLSLimitesAprobadosPaisFields.NombrePais]: z.string(),
    [OperacionLCLSLimitesAprobadosPaisFields.FechaUltMod]: z.coerce.date(),
    [OperacionLCLSLimitesAprobadosPaisFields.UsuarioUltMod]: z.string(),
    [OperacionLCLSLimitesAprobadosPaisFields.IdMensaje]: z.number(),
    [OperacionLCLSLimitesAprobadosPaisFields.FechaAprobacion]: z.coerce.date().nullable(),
    [OperacionLCLSLimitesAprobadosPaisFields.ListaUnidadesNegocio]: z.array(schemaOperacionLCLSCuentaLimitesAprobadosUnidadNegocio)
});

export type OperacionLCLSCuentaLimitesAprobadosPais = z.infer<typeof schemaOperacionLCLSCuentaLimitesAprobadosPais>;

export const schemaListaOperacionLCLSCuentaLimitesAprobadosPais = z.array(schemaOperacionLCLSCuentaLimitesAprobadosPais);


export const schemaOperacionLCLSRelacionSchema = z.object({
    [OperacionLCLSRelacionFields.CodSectorComercial]: z.number(),
    [OperacionLCLSRelacionFields.CodClienteTipo]: z.number(),
    [OperacionLCLSRelacionFields.CodClienteSubTipo]: z.number(),
    [OperacionLCLSRelacionFields.DescClienteTipo]: z.string(),
    [OperacionLCLSRelacionFields.DescClienteSubTipo]: z.string(),
}).merge(schemaEntityWithId);

export type OperacionLCLSRelacion = z.infer<typeof schemaOperacionLCLSRelacionSchema>;